<template>
  <div>
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="3" />
    <div v-if="isCloseSkeletonScreen">
      <div class="image-main">
        <div class="photo_album" v-for="item,index in getPhotoList" :key="index">
          <h6 class="photo_album_title">{{index}}</h6>
          <div class="photo_item">
            <div
              class="photo-item-main"
              v-for="image,cindex in item"
              v-if="image.image"
              v-bind:key="cindex"
            >
              <img v-lazy="image.image" :preview="randomStr+index" alt="图片" @load="$previewRefresh" />
            </div>
          </div>
        </div>
      </div>
      <no-result v-if="!photoList.length" title="此用户没有发布内容"></no-result>
      <loading
        class="loadbox"
        style="padding: 12px 0;"
        loadType="small"
        :title="'正在加载中...'"
        v-if="listLoading"
      ></loading>
      <no-data msg="已经到底了~" v-if="!listLoading&&hasMore&&photoList.length"></no-data>
    </div>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import readMore from "@/components/readMore/";
import noResult from "@/base/no-result/";
import noData from "@/base/nodata/";

export default {
  name: "UserProfiles",
  components: {
    readMore,
    noResult,
    noData
  },
  computed: {
    userInfo() {
      return this.$store.state.userProfiles.userInfo;
    }
  },
  props: {
    pageType: {
      type: String,
      default: "teacher"
    }
  },
  data() {
    return {
      photoList: [],
      user_id: parseInt(this.$route.params.id),
      isCloseSkeletonScreen: false,
      pullup: true,
      beforeScroll: true,
      hasMore: false,
      listLoading: true,
      page: 1,
      randomStr: Math.random()
        .toString(36)
        .slice(-4),
      before: "",
      sort_id: ""
    };
  },
  computed: {
    getPhotoList() {
      let photoList = {};
      let key = "";
      this.photoList.forEach((item, index) => {
        if (item.space_time !== "") {
          key = item.space_time;
          photoList[key] = [item];
        } else {
          photoList[key].push(item);
        }
      });
      return photoList;
    }
  },
  created() {
    this.getConsumerPhotoList();
  },
  methods: {
    columnListMore() {
      if (this.hasMore) return;
      this.hasMore = true;
      this.before = this.photoList[this.photoList.length - 1].created_at;
      this.sort_id = this.photoList[this.photoList.length - 1].id;
      this.getConsumerPhotoList();
    },
    //用户个人主页  相册
    async getConsumerPhotoList() {
      let data = await UserProfilesApi.getConsumerPhotoList(
        this.user_id,
        this.before,
        this.sort_id
      );
      this.isCloseSkeletonScreen = true;
      if (this.before) {
        this.photoList = this.photoList.concat(data.list);
      } else {
        this.photoList = data.list;
      }
      this.$emit("scrollRefresh");
      this.isData(data.list);
    },

    isData(data) {
      if (!data.length) {
        this.listLoading = false;
        this.hasMore = true;
      } else {
        this.hasMore = false;
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.recommend {
  position: fixed;
  overflow: auto;
  top: 48px;
  width: 100%;
  padding-bottom: 50px;
  bottom: 0;
  background-color: #f0f0f0;
}

.recommend-content {
  height: 100%;
  overflow: hidden;
}

.image-main {
  background-color: #fff;
}

.photo_album {
  .photo_album_title {
    height: 35px;
    padding-left: 13px;
    font-size: 13px;
    color: @color-gray-middle;
    font-weight: 400;
    line-height: 39px;
  }

  .photo_item {
    padding: 0 6px 6px;
    display: flex;
    flex-wrap: wrap;

    .photo-item-main {
      width: 33.33%;
      height: 132px;
      display: inline-block;
      padding: 3px;
      box-sizing: border-box;

      > img {
        flex-shrink: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>